import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/my/absences/new-leave-request"
)({
  validateSearch: (params) => {
    const workflowId = Number(params?.workflowId)
    if (isNaN(workflowId)) {
      throw new Error("Invalid workflow id")
    }
    return { workflowId }
  },
  component: lazyImportRouteComponent(
    () => import("./-components/CreateRequestApprovalPage"),
    "CreateRequestApprovalPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () => context.context.t && context.context.t("RequestAbsence"),
    }
  },
})
